import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Navigate } from 'react-router-dom';

import { getToken, getWellFunnelToken } from 'api/utils/tokenManagement';

import { useUserLoggedIn } from 'hooks/user';

import Header from 'components/Header/Header';
import Sidebar from 'components/Sidebar';

import routes from '../routes';
import { LayoutProps } from '../types';

import * as S from './styled';

const CabinetLayout = ({ children, titleKey }: LayoutProps) => {
    const { t } = useTranslation();

    const isUserLoggedIn = useUserLoggedIn();

    useEffect(() => {
        document.title = t(titleKey);
    }, [titleKey]);

    if (!isUserLoggedIn) return <Navigate to={routes.PUBLIC.LOGIN.path} />;

    const token = getToken() || getWellFunnelToken();

    return (
        <S.BodyContainer>
            <Header noControls={Boolean(token)} />

            <S.MainContainer>
                <Sidebar />
                {children}
            </S.MainContainer>
        </S.BodyContainer>
    );
};

export default CabinetLayout;
